import React from 'react';
import { Card, Row, Space, Typography, Checkbox } from 'antd';
import { Link } from 'react-router-dom';
import { RightOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { singularizeCollectionName } from '../entity/shared/utils';
import { ReactComponent as FolderOutlined } from '../../images/folder-outline.svg';
import { useTranslation } from '../../i18n/useTranslation';

const styles = {
    row: {
        padding: '32px 16px 32px 12px',
    },
    title: {
        margin: '0 8px 0 0',
    },
};

const LinkBlock = styled(Link)`
    display: block;
    position: relative;

    &:hover,
    &:focus {
        z-index: 2;
    }
`;

const ResultCard = styled(Card)`
    && {
        border-color: ${(props) => props.theme.styles['border-color-base']};
    }
    &&:hover {
        box-shadow: none;
    }
`;

export interface BrowseResultProps {
    url: string;
    name: string;
    count?: number | undefined;
    type: string;
    selectedItems: string[];
    onClick?: () => void;
    handleItemCheck: (itemName: string, event) => void;
    showCheckbox?: boolean;
}

export default function BrowseResultCard({
    url,
    count,
    name,
    type,
    selectedItems,
    onClick,
    handleItemCheck,
    showCheckbox = true,
}: BrowseResultProps) {
    const { t } = useTranslation();
    let displayType = type;
    if (count === 1) {
        displayType = singularizeCollectionName(type);
    }
    return (
        <LinkBlock className="f-bottom-border" to={url} onClick={onClick}>
            <ResultCard hoverable aria-label={`${name} ${count} ${displayType}`}>
                <Row wrap={false} style={styles.row} justify="space-between" align="middle" className="f-pa-4-xs">
                    <Space size="middle" align="center" className="f-align-start-xs">
                        {showCheckbox && (
                            <Checkbox
                                aria-label={name}
                                checked={selectedItems.includes(name)}
                                onClick={(e) => handleItemCheck(name, e)}
                            />
                        )}
                        <FolderOutlined className="f-icon-size-md f-color-dark-black-s70" width={16} />
                        <Typography.Title
                            level={2}
                            style={styles.title}
                            className="f-text-big-content f-text-semibold f-color-dark-black-s100"
                        >
                            {name}
                        </Typography.Title>
                    </Space>
                    <Space className="f-width-100-xs f-justify-between-xs f-mt-2-xs">
                        {count && (
                            <Typography.Text className="f-text-medium-content f-color-dark-black-s70 truncate shrink">
                                {count} {t(displayType)}
                            </Typography.Text>
                        )}
                        <RightOutlined className="f-icon-size-xs f-color-dark-black-s70" />
                    </Space>
                </Row>
            </ResultCard>
        </LinkBlock>
    );
}
